export default __webpack_public_path__ + "static/media/leadership.3b91c988.svg";